import { Switch } from '@thanx/uikit/switch'
import { buildTranslate } from 'locales'
import isEmpty from 'lodash/isEmpty'

import { useFormModel } from '../../FormModel'
import NotPurchase from './NotPurchase'

const t = buildTranslate(
  'redeem_manager.builder.steps.configuration.online_redemption_card'
)

const ItemRedemption = () => {
  const { model, setModel, commitModel } = useFormModel()
  const {
    onlineDiscountedProductIds,
    onlineRequiredProductIds,
    onlineDiscountedModifierIds,
    onlineModifierDiscountIds,
    onlineModifierDiscountsAdvanced,
    typeItem,
    discountScope,
  } = model || {}

  // Entering or leaving advanced mode starts the modifier discounts from the
  // restrictions, so both lists match until the merchant edits one.
  const setModifierDiscountsAdvanced = (advanced: boolean) =>
    (commitModel ?? setModel)({
      ...model,
      onlineModifierDiscountsAdvanced: advanced,
      onlineModifierDiscountIds: [...(onlineDiscountedModifierIds ?? [])],
    })

  const itemSubtype = typeItem?.subtype

  const displayDiscountedProducts =
    itemSubtype === 'item' ||
    itemSubtype === 'bogo/item' ||
    (itemSubtype === null && !isEmpty(onlineDiscountedProductIds))
  const displayRequiredProducts =
    itemSubtype === 'bogo/item' ||
    itemSubtype === 'bogo/purchase' ||
    (itemSubtype === null && !isEmpty(onlineRequiredProductIds))

  return (
    <>
      <Switch
        condition={typeItem?.subtype !== 'purchase'}
        fallback={<p className="grey-70">{t('will_be_able_to_redeem')}</p>}
      >
        <NotPurchase
          discountedModifierIds={onlineDiscountedModifierIds}
          modifierDiscountIds={onlineModifierDiscountIds}
          modifierDiscountsAdvanced={onlineModifierDiscountsAdvanced}
          onModifierDiscountsAdvancedChange={setModifierDiscountsAdvanced}
          discountedProductIds={onlineDiscountedProductIds}
          requiredProductIds={onlineRequiredProductIds}
          typeItem={typeItem}
          discountScope={discountScope}
        />
      </Switch>
      <Switch condition={displayRequiredProducts && !displayDiscountedProducts}>
        <p className="body-text-14 bold">{t('then_entire_purchase')}</p>
      </Switch>
    </>
  )
}

export default ItemRedemption
